import $http from '../connectionProxy'

export const get = studentId => $http.get(`/responsibles_area/students/${studentId}/siblings`)

export const getModel = studentId => $http.get(`/responsibles_area/students/${studentId}/siblings/new`)

export const edit = (studentId, siblingid) => $http.get(`/responsibles_area/students/${studentId}/siblings/${siblingid}/edit`)

export const create = (studentId, data) => $http.post(`/responsibles_area/students/${studentId}/siblings`, data)

export const update = (studentId, siblingId, data) => $http.patch(`/responsibles_area/students/${studentId}/siblings/${siblingId}`, data)

export const remove = (studentId, siblingId) => $http.delete(`/responsibles_area/students/${studentId}/siblings/${siblingId}`)
